function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRaiseHandFill = function SvgRaiseHandFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5c7f"
    },
    d: "M3.194 12.944c.006.01.678 1.447.875 2.188C4.652 17.333 6.42 24 12.59 24l.126-.001c2.378-.034 4.109-.625 5.29-1.805 1.43-1.43 2.218-3.3 2.218-5.27L20.171 6.14c0-.654-.531-1.185-1.185-1.185-.653 0-1.185.531-1.185 1.185l-.021 5.946a.5.5 0 0 1-.5.499h-.001a.5.5 0 0 1-.5-.5v-8.96a1.092 1.092 0 0 0-1.09-1.09H15.5a1.092 1.092 0 0 0-1.085.983v8.293a.5.5 0 0 1-1 0V1.09A1.092 1.092 0 0 0 12.323 0h-.19a1.092 1.092 0 0 0-1.09 1.09l.026 9.833a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.499l-.025-7.616a1.092 1.092 0 0 0-1.066-.861h-.19a1.092 1.092 0 0 0-1.09 1.09v8.997l1.52 2.594a.5.5 0 0 1-.86.51l-2.5-4.172a1.538 1.538 0 0 0-1.34-.79 1.525 1.525 0 0 0-1.324 2.268Z",
    fill: "#FF5C7F"
  }));
};
export default SvgRaiseHandFill;